export enum UserRole {
  ADMIN = 'admin',
  TEACHER = 'teacher',
  STUDENT = 'student',
  COMPANY = 'company',
}

export enum AccountStatus {
  INACTIVE = 'inactive',
  ACTIVE = 'active',
  BANNED = 'banned',
  DISABLED = 'disabled',
  DELETED = 'deleted',
}

export interface SocialLinks {
  linkedin?: string;
  github?: string;
  twitter?: string;
  portfolio?: string;
  facebook?: string;
  instagram?: string;
}

export interface User {
  _id?: string;
  email: string;
  password: string;
  firstName: string;
  lastName: string;
  companyName?: string;
  role: UserRole;
  emailVerified: boolean;
  emailVerificationToken?: string;
  emailVerificationExpires?: Date;
  accountStatus: AccountStatus;
  lastLoginAt?: Date;
  lastLoginIp?: string;
  lastLoginDevice?: string;
  score?: number;
  xp?: number;
  level?: number;
  rank?: number;
  skills?: string[];
  currentToken?: string;
  resetPasswordOtp?: string;
  resetPasswordOtpExpires?: Date;
  resetPasswordOtpVerified?: boolean;
  socialLinks?: SocialLinks;
  createdAt?: Date;
  updatedAt?: Date;
}

export interface UserResponse extends Omit<User, 'password' | 'currentToken' | 'resetPasswordOtp' | 'emailVerificationToken'> {
  id: string;
}

export interface Certificate {
  id: string;
  certificateId: string;
  courseId: string;
  courseName: string;
  issueDate: Date;
  expiryDate: Date;
  pdfUrl?: string;
}

export interface LevelProgress {
  total: number;
  level: number;
  currentLevelXP: number;
  nextLevelXP: number;
  xpInCurrentLevel: number;
  progressPercentage: number;
  xpToNextLevel: number;
}

export interface RankingInfo {
  rank: number;
  totalStudents: number;
  percentile: number;
}

export interface LeaderboardEntry {
  userId: string;
  firstName: string;
  lastName: string;
  xp: number;
  level: number;
  rank: number;
}

export interface ProfileStats {
  user: {
    id: string;
    firstName: string;
    lastName: string;
    email: string;
    role: UserRole;
  };
  xp: LevelProgress;
  ranking: RankingInfo;
  skills: string[];
  certificates: Certificate[];
  leaderboard: LeaderboardEntry[];
}
